<template>

    <div class="layout__container">
        <div class="layout__border__radius-10 layout__width-100 layout__position-left layout__padding-15-0 text__align-center text__colour-teal">
            <h2>Forgotten Password</h2>
            <p class="layout__padding__top-10px">Something maybe like we'll send you a link to reset your password</p>
        </div>


        <el-form :model="reset" status-icon ref="reset" :rules="rules" class="layout__padding-clear">
            <el-form-item prop="resetEmail">Registered Email Address <span class="text__colour-red">*</span>
                <el-input class="layout__width-75 layout__padding-clear layout__position-right" placeholder="Email Address"
                          v-model="reset.resetEmail" clearable
                          autofocus></el-input>
            </el-form-item>


            <el-button
                    class="button-teal button__base layout__margin__top-10 layout__position-center layout__margin__top-4"
                    v-on:click="sendResetLink('reset')">
                Send Reset Link
            </el-button>
        </el-form>




    </div>

</template>

<script>
    import Vue from 'vue';
    import Axios from 'axios';
    import Element from 'element-ui';
    import {axios} from '@/mixins/Axios.js';

    Vue.use(Element);

    export default {
        name: "forgotPassword",
        mixins: [
            axios
        ],
        mounted() {
            document.getElementById("popup").style.display = "none";
        },
        created() {
            document.getElementById("popup").style.display = "none";
        },
        data() {
            return {
                reset: {
                    resetEmail: ''
                },
                rules: {
                    resetEmail: [{
                        required: true, message: 'required registered email address', trigger: 'blur'
                    }]
                }
            }

        },
        methods: {
            sendResetLink(reset) {
                this.$refs[reset].validate((valid) => {
                    if (valid) {

                        const forogttenPassword = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/ForgotPassword`

                        const forgotPasswordBody = {
                            "userNameOrEmailAddress": this.reset.resetEmail
                        }

                        Axios.post(forogttenPassword, forgotPasswordBody, this.returnHeaderNoToken())
                            .then(response => {
                                console.log(response)
                            })
                    }
                })
            }
        }
    };
</script>